import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"
import { API_UPDATE_DEFAULT_BANK_REQUESTS_URL } from "../constants"
import { RootState } from "../../store/store"
import { IConfirmUpdateDefaultBankRequestRequest } from "../interface"
import { axios } from "../axios"

async function confirm(token: string | null, req: IConfirmUpdateDefaultBankRequestRequest) {
  const response = await axios(`${API_UPDATE_DEFAULT_BANK_REQUESTS_URL}/${req.requestId}/confirm`, {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    data: {
      otp: req.otp
    }
  })
  // TODO: обработка ошибок
  return response.data
}

export const useConfirmUpdateDefaultBankRequest = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<void, void, IConfirmUpdateDefaultBankRequestRequest>({
    mutationFn: (req) => confirm(token, req),
    retry: false,
  })
}
